import React from "react";

import { FullscreenInput, TextInput } from "components";

import { styles } from "./styles";

const BaseInput = ({ rtl, ...props }) => (
  <TextInput
    placeholderTextColor={styles._input && styles._input.color}
    style={[styles.text, { textAlign: rtl ? "right" : "left" }]}
    maxLength={100}
    {...props}
  />
);

export const Input = props => (
  <FullscreenInput component={BaseInput} {...props} />
);
